Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "OfferingCTA777952320",
  {"buttonWrapper":"OfferingCTA777952320--buttonWrapper","root":"OfferingCTA777952320--root"},
  "",
  8,
  "OfferingCTA777952320"
);

